import { useState } from "react";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { PageHeader } from "@/components/common";
import { GLOSSARY } from "@/lib/glossary";

export default function Glossary() {
  const [q, setQ] = useState("");
  const rows = Object.entries(GLOSSARY)
    .filter(([, [p, o, t]]) => `${p} ${o} ${t}`.toLowerCase().includes(q.toLowerCase()))
    .sort((a, b) => a[1][0].localeCompare(b[1][0]));
  return (
    <div className="space-y-6">
      <PageHeader overline="Help" title="Glossary — words explained" explain="Every money word used in this app, in simple language. Look for the small (i) icon next to numbers anywhere in the app to see these explanations." />
      <div className="relative max-w-md">
        <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-stone-400" />
        <Input className="pl-9" placeholder="Search a word, e.g. shares, interest" value={q} onChange={(e) => setQ(e.target.value)} data-testid="glossary-search" />
      </div>
      <div className="grid gap-3 sm:grid-cols-2" data-testid="glossary-list">
        {rows.map(([k, [plain, official, text]]) => (
          <div key={k} className="rounded-xl border border-stone-200/80 bg-white p-4 lift" data-testid={`glossary-${k}`}>
            <div className="font-heading font-semibold text-brand">{plain}</div>
            <p className="mt-1 text-sm leading-snug text-stone-700">{text}</p>
            {official !== plain && <p className="mt-2 text-xs text-stone-500">Official term: <b>{official}</b></p>}
          </div>
        ))}
        {!rows.length && <p className="text-sm text-stone-500">No matching words.</p>}
      </div>
    </div>
  );
}
